import { IdName } from '../../models/id-name';
import { UiSelectOptions } from '../../models/ui-select-option.model';
import { IDepartmentInfo } from '../models/tenant-user-access.model';
import { isDepartmentPaused } from './is-department-paused';

export type DepartmentSelectOption = IdName & { isPaused?: boolean };

export function buildDepartmentPauseById(
  departmentInfos: IDepartmentInfo[] | null | undefined
): Record<string, boolean> {
  return (departmentInfos ?? []).reduce<Record<string, boolean>>((pauseById, department) => {
    pauseById[department.id] = isDepartmentPaused(department);
    return pauseById;
  }, {});
}

export function enrichSelectOptionsWithDepartmentPause(
  options: IdName[] | null | undefined,
  pauseById: Record<string, boolean> | null | undefined
): DepartmentSelectOption[] {
  if (!options?.length) {
    return [];
  }

  return options.map((option) => ({
    ...option,
    isPaused: pauseById?.[option.id] ?? false,
  }));
}

export function mapDepartmentInfosToSelectOptions(
  departments: IDepartmentInfo[] | null | undefined
): DepartmentSelectOption[] {
  return (departments ?? []).map((department) => ({
    id: department.id,
    name: department.name,
    isPaused: isDepartmentPaused(department),
  }));
}
